/**
 * Created by christian on 3/5/2015.
 */
module cr.entity
{
    export class EntityNode implements ITreeNode {
        id:string;
        collapsed:boolean;


        displayName()
        {
            if (!angular.isDefined(this.entity.Id) || this.entity.Id=="0") return "#NEW";
            var toRet=this.entity[this.definition.TreeExpression];
            if (toRet) return toRet;
            return ""+this.entity.Id;
        }

        parent:cr.entity.ITreeNode;
        nodes:Array<cr.entity.ITreeNode>;
        TreeManager:cr.entity.ITreeManager;

        GetPath= ()=>
        {
            var base="";
            if (this.parent!=null && angular.isFunction((<any>this.parent).GetPath))
            {
                return (<any>this.parent).GetPath()+":"+this.entity.Id;
            }

            return this.definition.Name+":"+this.entity.Id;
        }

        UpdateEntity(entity:any)
        {
            this.entity=entity;
            this.BuildNode();
        }

        BuildNode()
        {
            if (angular.isDefined(this.entity.Id) && this.entity.Id!="0" && this.nodes.length==0){
                for (var relName in this.definition.ChildRelations){
                    var rel=this.definition.ChildRelations[relName];
                    console.log("child: "+relName+" - "+rel.ChildDefinitionName+" "+angular.toJson(this.entity["Chl"+relName]));

                    var toAdd=new EntityListTreeNode(this.entityService, this.moduleDetail.Definitions[rel.ChildDefinitionName],this.moduleDetail,rel);
                    this.nodes.push(toAdd);

                    if (this.entity["Chl"+relName]){
                        var childEntities=this.entity["Chl"+relName];
                        for (var chlId in childEntities)
                        {
                            var chl=childEntities[chlId];
                            var chlNode=new EntityNode(this.entityService, this.moduleDetail.Definitions[rel.ChildDefinitionName],this.moduleDetail,chl);

                            //this.TreeManager.AddNode(chl,toAdd);
                            toAdd.nodes.push(chlNode);
                        }
                    }
                }
            }
        }

        Action(actionName:string, args?:any) {
            //console.log("we received an event on an entity: " + actionName + " [" + this.definition.DisplayName + "]");
            switch (actionName) {
                case "click":
                    //this.nodes.push(new NodeBase("Click","clk"+this.nodes.length,this));
                    this.TreeManager.SetContent("cr-entity", this, this.id);

                    break;
            }
        }

        getPath=()=>
        {
            //
        }


        constructor(public entityService:IEntityService,public definition:EntityDefinitionView,public moduleDetail:EntityModule,public entity?:any) {
            this.id = definition.Name;
            this.nodes = [];
            //this.entity=entity;
            if (!angular.isDefined(entity)) this.entity={};

            this.BuildNode();
        }
    }

    class EntityCtrl
    {
        treeNode:EntityNode;

        Submit=()=>{
            console.log("new entity: "+angular.toJson(this.$scope.data));

            this.entityService.addUpdate(this.treeNode.GetPath(),this.$scope.data).then(newEntity=>{
                    this.treeNode.UpdateEntity(newEntity);
                        //console.log("newEntity:"+angular.toJson(newEntity) );
                    this.notificationService.addNotification(cr.infrastructure.notification.notificationType.Info,"SAVED");
                    this.$scope.data=newEntity;
                }
            );

        }

        constructor(private $scope,private entityService:IEntityService,private notificationService:cr.infrastructure.notification.INotificationService){
            this.$scope.formDefinition = {};
            $scope.formOptions = {
                context:'ENTITY',
                uniqueFormId: 'clientForm',
                hideSubmit: true
            };

            this.$scope.data ={};
            $scope.Submit=()=>this.Submit();


            $scope.$watch('tree.currentNode.id', (val)=> {
                //console.log('Current tree node changed crEntity: ' + val);
                this.treeNode = <EntityNode>$scope.tree.currentNode;
                this.$scope.data = angular.copy(this.treeNode.entity);
                $scope.treeNode = this.treeNode;
                entityService.getFormDefinition(this.treeNode.moduleDetail.Name, this.treeNode.definition.Name).then(definition=>
                    {this.$scope.formDefinition = definition.data;
                        console.log(definition);}
                );
            });
        }
    }

    entityModule.directive('crEntity', function () {
        return {
            restrict: "E",
            scope: true,
            templateUrl: "modules/entity/views/entity.html",
            require: "^crTreeViewer",
            link: function (scope, element, attrs, treeViewer) {
                scope.treeViewer = treeViewer;
                scope.tree = treeViewer.getTree();
            },
            controller: ['$scope','entityService','notificationService',EntityCtrl]
        }
    });
}
